module.exports = __webpack_public_path__ + "img/icon1@2x.ff8bd45e.png";